module.exports = __webpack_public_path__ + "static/media/view-icon.85368a16.svg";